/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import { yupResolver } from '@hookform/resolvers/yup';
import {
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  useToast,
} from 'alm-react-components';
import { confirmResetPassword, fetchUserAttributes, signIn } from 'aws-amplify/auth';
import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as yup from 'yup';
import { ActionType, APPROUTES, BackendRespose, constants, corporateKeys, StatusCode, SubscriptionStatus } from '../../assets/constants/constants';
import { analytics_category, analytics_event, analytics_label, appcues_event } from '../../assets/constants/staticContentConstants';
import eye from '../../assets/images/eye.svg';
import eyeslash from '../../assets/images/eyeslash.svg';
import { AppContext } from '../../context/AppProvider';
import useGaEventTracking from '../../hooks/UseGaEventTracking';
import { putAppCuesData } from '../../lib/appcues';
import { authSession, awsErrorCodeMsgTosterOnLogin, encrptText, errorTosterCodeMsg, removeChainlitPopup } from '../../lib/utils';
import { apis } from '../../services/alm';
import { deviceDetails, getAlmToken, getSllUser, updateLanguageSetting } from '../../services/user';

type Inputs = {
  confirmationCode: string;
  newPassword: string;
  confirmPassword: string;
};

type OtpResetPasswordFormProps = {
  username: string;
  setUsername: (username: string) => void;
  setCodeSend: (sendCode: boolean) => void;
  sendOtp: (username: string) => void;
};
const OtpResetPasswordForm = (Props: OtpResetPasswordFormProps) => {
  const { t, i18n } = useTranslation();
    const gaEventTracker = useGaEventTracking();

  const [revealConfirm, setRevealCOnfirm] = useState(false);
  const [revealPassword, setRevealPassword] = useState(false);
  const [error, setError] = useState('');
  const [codeError, setCodeError] = useState('');
  const [loading, setLoading] = useState(false);
  const [seconds, setSeconds] = useState(30);
  const [isActive, setIsActive] = useState(true);
  const [query] = useSearchParams();
  const attempts: any = query.get("attempts");
  const [counter, setCounter] = useState(attempts == 0 ? 0 : 3);
  const navigate = useNavigate();
  const {toast} = useToast();
  const {state, dispatch} = useContext(AppContext);

  useEffect(() => {
    let intervalId: any;
    if (isActive && counter > 0) {
      intervalId = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds === 0) {
            clearInterval(intervalId);
            setIsActive(false);
            return 0;
          } else {
            return prevSeconds - 1;
          }
        });
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [isActive]);

  const setAccoutDataAndRedrection = async(userType:string,userStatus:string)=>{
    const language = localStorage.getItem("locale") || constants.dutchLocale;
    const languageCode = localStorage.getItem("i18nextLng") || constants.dutchCode;
    await deviceDetails(constants.login);
    getAlmToken()
    .then(async (learnerRes: any) => {
      if (learnerRes.status === StatusCode.SUCCESS) {
        localStorage.setItem(
          "access_token",
          learnerRes.data.access_token
            ? learnerRes.data.access_token
            : ""
        ); 
        const now = new Date();
        localStorage.setItem('login_time', now.toISOString());
        await apis.checkAlmUser().then(async (res: any) => {
          const userLanguage = res?.data?.attributes?.uiLocale;
          if (!userLanguage || userLanguage !== language) {
            localStorage.setItem('i18nextLng', languageCode);
            localStorage.setItem('locale', language);
            await apis.updateUserContent(
              learnerRes?.data?.user_id,
              language
            );
            await updateLanguageSetting(language);
            i18n.changeLanguage(languageCode);
          }
          dispatch({type: ActionType.SET_LOADING, payload: false});

          if(userType === corporateKeys.CORPORATE_OWNER || userType === corporateKeys.CORPORATE_LEARNER){
            if(userStatus === constants.COMPLETED ){
              navigate(APPROUTES.home);
            }else{
              navigate(APPROUTES.profile);
            }
          } else if(userType === corporateKeys.LEARNER){
            if(userStatus === constants.COMPLETED ){
              navigate(APPROUTES.home);
            }else{
              navigate(APPROUTES.profile);
            }
          }else{
            if(userStatus === constants.COMPLETED ){
              navigate(APPROUTES.home);
            }else{
              navigate(APPROUTES.profile);
            }
          }
        });
      }else if( learnerRes.status === StatusCode.ERR_BAD_REQUEST){
        if(learnerRes.code===StatusCode.USER_NOT_PRESNT_IN_ALM){
          toast({
            description: t('Validations.userNotpresentinALM'),
            variant: 'error',
          });
        }
      }
      else {
        navigate("/");
      }
    })
    .catch(() => {
      dispatch({
        type: ActionType.LOTTIE_ANIMATION,
        payload: false,
      });
    });
  }
  const doLogin = async (headlessUserDetail:any) => {

    // Remove chainit popup
    removeChainlitPopup()
    
    const accessToken = await authSession();
    localStorage.setItem("token", accessToken ? accessToken : "");
    fetchUserAttributes().then(async () => {
      //Set token
      const data = headlessUserDetail;
      const items = {
          value: null,
          currency: null,
          transaction_id: null,
          items: [{}],
          userId:data.userId,
          login_method:constants.Custom,
          device:constants.WEB
      };
        gaEventTracker(analytics_event.login,analytics_category.buttonCLickLogin,analytics_label.loginLabel,items);
        putAppCuesData({
          eventName:appcues_event.login,
          userId: data?.email,
          time_since_last_login: new Date().toISOString(),
          email:data?.email})
          dispatch({ type: ActionType.IS_AUTH, payload: true });
           
          if (data.roles.includes(corporateKeys.CORPORATE_OWNER) ) {
            setAccoutDataAndRedrection(corporateKeys.CORPORATE_OWNER,data.userStatus)
          }else if ( data.roles.includes(corporateKeys.CORPORATE_LEARNER)) {
            setAccoutDataAndRedrection(corporateKeys.CORPORATE_LEARNER,data.userStatus)
          } else {
            if (  data.subscriptionStatus === SubscriptionStatus.active || data.subscriptionStatus === SubscriptionStatus.trial ) {
              if (data.userStatus === constants.COMPLETED) {
                setAccoutDataAndRedrection(corporateKeys.LEARNER,data.userStatus)
              } else{ 
                dispatch({type: ActionType.SET_LOADING, payload: false});
                navigate(APPROUTES.profile);
              }
            } else if (
              data.subscriptionStatus === SubscriptionStatus.pending || data.subscriptionStatus === SubscriptionStatus.canceled || data.subscriptionStatus === SubscriptionStatus.trialOver
            ) {
              dispatch({type: ActionType.SET_LOADING, payload: false});
              if (data.subscriptionStatus === SubscriptionStatus.trialOver) {
                navigate(APPROUTES.selectCurrency);
              } else {
                navigate(APPROUTES.selectMembership);
              }
            }
          }
    });
  };
  async function onhandleSubmitCode(values: Inputs) {
    const params = {
      username: Props.username,
      confirmationCode: values.confirmationCode,
      newPassword: encrptText(values.newPassword),
    };
    dispatch({type: ActionType.SET_LOADING, payload: true});

    confirmResetPassword(params)
      .then(async () => {
        dispatch({type: ActionType.SET_LOADING, payload: false});
        toast({
          description: (t("ResetPasswordForm.passwordUpdateSuccessMsg")),
          variant: 'success',
        });
        const params = {
          username: Props.username,
          password: encrptText(values.newPassword),
        };
        if(state.isAuthenticated){
          navigate('/home')
        }
        else{
          dispatch({type: ActionType.SET_LOADING, payload: true});
           
          await getSllUser(params.username).then(async (res: any) => {
                const headlessUserDetail = res.data;
                let loginActionFlag:boolean=true
                let errorTransition =''
                if(res.status == StatusCode.ERR_BAD_REQUEST){
                  errorTransition =BackendRespose.userNotFoundError; 
                  loginActionFlag=false
                }
                else if(res.status == StatusCode.SUCCESS && headlessUserDetail?.roles.includes(corporateKeys.LEARNER)){
                  if( headlessUserDetail?.syncStatus== constants.EMAIL_UPDATED && params.username !==headlessUserDetail?.email){
                    errorTransition=BackendRespose.userNotFoundError;
                    loginActionFlag=false
                  }
                }
                else if(res.status == StatusCode.SUCCESS && !headlessUserDetail?.roles.includes(corporateKeys.LEARNER )){
                  if( headlessUserDetail?.corporateSubscriptionStatus == constants.INACTIVE ){
                    errorTransition=BackendRespose.subscriptionExpired; 
                    loginActionFlag=false
                  }
                  else if(headlessUserDetail?.corporateUserStatus === constants.DELETED) {
                    errorTransition=BackendRespose.accountDeletedMessage;
                    loginActionFlag=false
                  } else if( headlessUserDetail?.corporateUserStatus !== constants.ACTIVE ){  
                    errorTransition=BackendRespose.accountDeactivatedMessage;  
                    loginActionFlag=false
                  } 
                 else  if(headlessUserDetail?.syncStatus== constants.EMAIL_UPDATED && params.username !==headlessUserDetail?.email){
                  errorTransition=BackendRespose.userNotFoundError;
                  loginActionFlag=false
                  }
                } 
                if(loginActionFlag){
                  loginAction(headlessUserDetail,params)
                }else{
                  dispatch({type: ActionType.SET_LOADING, payload: false});
                  errorTosterCodeMsg(errorTransition);
                  return;
                }
              })
        }
      })
      .catch(error => {
        dispatch({type: ActionType.SET_LOADING, payload: false});
        if (error.name == 'UserNotFoundException') {
          setError('User Not Found');
        } else if (error.name == 'ExpiredCodeException') {
          setCodeError(t('Validations.codeExpiredError'));
        } else if (error.name == 'CodeMismatchException') {
          setCodeError(t('ResetPasswordForm.invalidVerifiationCodeMsg'));
        } else if (error.name == 'LimitExceededException') {
          setCodeError(t('ResetPasswordForm.attemptLimitExceededMsg'));
        } else {
          setError(error.name);
        }
      });
  }

  const loginAction=(headlessUserDetail:any,params:any)=>{
      signIn(params)
      .then(() => {
          // Navigate to home or dashboard
          doLogin(headlessUserDetail);
      })
      .catch((error) => {
        const { message }: { name: any | undefined; message: any | undefined } = error;
        dispatch({type: ActionType.SET_LOADING, payload: false});
        awsErrorCodeMsgTosterOnLogin(message);
      });
  }

  const reSendOtp = async () => {
    setLoading(true);
    form2.reset();
    setCodeError("");
    try {
      await Props.sendOtp(Props.username);
      setIsActive(true);
      setSeconds(30);
    } catch (error) {
      // Handle the error if needed
      console.error("Error sending OTP:", error);
      setCounter(3);

      toast({
        description: t("UpdatePassword.failOtpMsg"),
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  
  const schema2 = yup.object({
    confirmationCode: yup
      .string()
      .required(t('Validations.verificationRequired'))
      .matches(/^[0-9]+$/, t('Validations.digitsRequired'))
      .min(6, t('Validations.min&MaxDigits'))
      .max(6, t('Validations.min&MaxDigits')),
    newPassword: yup
      .string()
      .required(t('Validations.passwordRequired'))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
        t('Validations.msgPasswordValidation')
      ),
    confirmPassword: yup
      .string()
      .required(t('Validations.confirmPasswordRequired'))
      .oneOf([yup.ref('newPassword')], t('Validations.passwordNotMatch'))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
        t('Validations.msgPasswordValidation')
      ),
  });

  const form2 = useForm<Inputs>({
    resolver: yupResolver(schema2),
    mode: 'onChange',
    defaultValues: {
      newPassword: '',
      confirmPassword: '',
      confirmationCode: '',
    },
  });
  const handleChange = () => {
    if (form2.getValues('confirmPassword')) {
      form2.trigger('confirmPassword');
    }
  };
  return (
    <Form {...form2}>
      {
        <>
          <form
            onSubmit={form2.handleSubmit(onhandleSubmitCode)}
            onChange={handleChange}
            className=""
            autoComplete="off"
          >
            <div className="grid w-full items-center gap-4 mb-6">
              <div className="flex flex-col space-y-1.5 text-base">
                <FormField
                  control={form2.control}
                  name="confirmationCode"
                  render={({field}) => (
                    <FormItem>
                      <FormLabel className="font-opensansSemiBold text-xs tracking-wider">
                        <div className="flex justify-between">
                          <div><span dangerouslySetInnerHTML={{ __html: t('SignUp.sendVerificationCode') + " *" }} /></div>
                          {isActive && counter && (
                            <div className="">{seconds}s</div>
                          )}
                        </div>
                      </FormLabel>
                      <FormControl>
                        <Input
                          maxLength={6}
                          placeholder={(t("ResetPasswordForm.enterVerificationCode"))}
                          {...field}
                          className="h-auto py-4 text-base pe-16 opacity-100"
                          autoComplete="new-password"
                        />
                      </FormControl>
                      <FormMessage>{codeError}</FormMessage>
                    </FormItem>
                  )}
                />
              </div>
            </div>
            <div className="grid w-full items-center gap-4 mb-6">
              <div className="flex flex-col space-y-1.5 text-base">
                <FormField
                  control={form2.control}
                  name="newPassword"
                  render={({field}) => (
                    <FormItem className="relative">
                      <FormLabel className="font-opensansSemiBold text-xs tracking-wider">
                        <span dangerouslySetInnerHTML={{ __html: t("ResetPasswordForm.newPassword") + " *" }} />
                      </FormLabel>
                      <FormControl>
                        <Input
                          type={revealPassword ? 'text' : 'password'}
                          placeholder={(t("ResetPasswordForm.enterNewPassword"))}
                          {...field}
                          className="h-auto py-4 text-base pe-16 opacity-100"
                          autoComplete={(t("ResetPasswordForm.new-Password"))}
                        />
                      </FormControl>
                      {revealPassword ? (
                        <>
                          <img
                            className="absolute top-[45px] right-[16px] w-[26px] h-[16px]"
                            onClick={() => setRevealPassword(!revealPassword)}
                            src={eye}
                            alt="No image"
                          />
                        </>
                      ) : (
                        <>
                          <img
                            className="absolute top-[41px] right-[15px] w-[29px] h-[22px]"
                            onClick={() => setRevealPassword(!revealPassword)}
                            src={eyeslash}
                            alt="No image"
                          />
                        </>
                      )}
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
            </div>
            <div className="grid w-full items-center gap-4 mb-6">
              <div className="flex flex-col space-y-1.5 text-base">
                <FormField
                  control={form2.control}
                  name="confirmPassword"
                  render={({field}) => (
                    <FormItem className="relative">
                      <FormLabel className="font-opensansSemiBold text-xs tracking-wider">
                      <span dangerouslySetInnerHTML={{ __html: (t("ResetPasswordForm.confirmPasword")) + " *" }} />
                      </FormLabel>
                      <FormControl>
                        <Input
                          type={revealConfirm ? 'text' : 'password'}
                          placeholder={(t("ResetPasswordForm.confirmPasword"))}
                          {...field}
                          className="h-auto py-4 text-base pe-16 opacity-100"
                        />
                      </FormControl>
                      {revealConfirm ? (
                        <>
                          <img
                            className="absolute top-[45px] right-[16px] w-[26px] h-[16px]"
                            onClick={() => setRevealCOnfirm(!revealConfirm)}
                            src={eye}
                            alt="No image"
                          />
                        </>
                      ) : (
                        <>
                          <img
                            className="absolute top-[41px] right-[15px] w-[29px] h-[22px]"
                            onClick={() => setRevealCOnfirm(!revealConfirm)}
                            src={eyeslash}
                            alt="No image"
                          />
                        </>
                      )}
                      <FormMessage>{error}</FormMessage>
                    </FormItem>
                  )}
                />
              </div>
            </div>
            <Button className="w-full h-auto py-2 text-base font-opensansSemiBold mt-6 mb-4">
              <span dangerouslySetInnerHTML={{ __html: t("Common.continue") }} />
            </Button>
          </form>
          {loading && <div className="loader"><span dangerouslySetInnerHTML={{ __html: t("Common.loading") }} /></div>}
          <div className="flex justify-between ">
            {!counter && <p><span dangerouslySetInnerHTML={{ __html: t("Validations.tryAfterSometimeMessage") }} /></p>}
            {counter && (
              <Button
                onClick={() => {
                  seconds === 30 || seconds === 0 ? reSendOtp() : "";
                }}
                variant={"link"}
                className={`mx-auto h-auto px-0 py-6 text-sm mb-6 underline dark:text-white ${
                  seconds < 30 && seconds > 0
                    ? "cursor-not-allowed"
                    : "cursor-pointer"
                }`}
                style={{ color: seconds < 30 && seconds > 0 ? "#adb3b5" : "" }}
              >
                <span dangerouslySetInnerHTML={{ __html: t('LogIn.resendCode') }} />
              </Button>
            )}
          </div>
        </>
      }
    </Form>
  );
};

export default OtpResetPasswordForm;
